import { render, staticRenderFns } from "./SalesOrderSelect.vue?vue&type=template&id=3468b30c&scoped=true"
import script from "./SalesOrderSelect.vue?vue&type=script&lang=js"
export * from "./SalesOrderSelect.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderSelect.vue?vue&type=style&index=0&id=3468b30c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3468b30c",
  null
  
)

export default component.exports